import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import * as ls from "./_csLcl";
import { a } from "./_csAbt";

import * as BtnC from './_cccBtnC';
import * as TblC from "./_ccmTblC";
import * as TextC from "./_ccbTextC";

import * as ica from 'src/ica';
import * as _cv_61 from './_cv_61___Mz';

let $_61rs = [] as ht.ls;

import * as BtnTopC from './_ccmBtnTopC';
export const B = (pz: ht.btnTopCz) => {
  return (
    cr.c(BtnTopC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
      }
    })
  )
};

export const L = (pz: ht.viewListCz) => {

  React.useEffect(() => {
    //hf.l(`_cv_61a 36: ${pz.cz.cdn}`)
    f.loadAllAsync({
      frcUdt: pz.sPz.udt,
      bfrAsync: () => [
        _cv_61.load_61rLsAsync({
          cdn: pz.cz.cdn,
        })
        .then((_ls: ht.ls) => {
          //hf.l(`_cv_61a 29: ${hf.s(_ls)}`);
          $_61rs = _ls
        })
      ]
    })
  }, [
    pz.cz.cdn,
  ]);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewListAbtz[_abtType] ? ica.viewListAbtz[_abtType]() : {};

  const _hdrs = [];
  const _cellCs = [
    {
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '対象年',
          }
        })
      ]
    },
    {
      boxStlz: a('dw/10 f/n'),
      oClds: [
      ]
    },
  ];
  _hdrs.push(
    {
      cellCs: _cellCs
    },
  );

  //hf.l(`_cv_61a 64: ${hf.s($_61rs)}`);
  const _rows = [] as ht.ls;
  $_61rs?.map( ( _dz: ht.dz ) => {
    const _cellCs = [
      {
        //boxStlz: a('f/0.25'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _dz._icn,
            }
          })
        ]
      },
      {
        boxStlz: a('dw/10 f/n'),
        oClds: [
          cr.c(BtnC.N, {
            key: -10,
            ... _abtz.bdyCz.btnCz,
            lblCz: {},
            pslPtyz: {
              onPress: () => {
                pz.sPz.set({
                  steps: [1],
                  phs: 'dpy',
                  _61r_fst: _dz._fst,
                })
              }
            },
          })
        ]
      },
    ];
    _rows.push(
      {
        cellCs: _cellCs
      },
    )
  });

  return (
    cr.c(TblC.N, {
      key: -30,
      ... _abtz.tblCz,
      srlCz: {
        srlStlz: {
          otrz: a('dwx/60'),
        },
      },
      hdrCz: {
        lineCs: _hdrs,
      },
      bdyCz: {
        lineCs: _rows,
      },
    })
  );
};

